export default "__VITE_ASSET__1d9812b9__"